import moment from 'moment';
import ReviewMember from './ReviewMember';
import Reference from './Reference';
import ReviewCriteria from './ReviewCriteria';

export default class FullTextReviewVote {
  constructor(data = {}) {
    this.id = data.id;
    this.optimisticId = data.optimisticId;
    this.reviewer = data.reviewer
      ? new ReviewMember(data.reviewer)
      : null;
    this.reference = data.reference
      ? new Reference(data.reference)
      : null;
    this.vote = data.vote;
    this.reasonReviewCriteria = data.reasonReviewCriteria
      ? new ReviewCriteria(data.reasonReviewCriteria)
      : null;
    this.notes = data.notes;
    this.blinded = !!data.blinded;
    this.archived = !!data.archived;
    this.createdAt = data.createdAt ? moment(data.createdAt) : null;
  }

  creationData() {
    return {
      id: this.id,
      reviewer: this.reviewer.id,
      reference: this.reference.id,
      vote: this.vote,
      reasonReviewCriteria: this.reasonReviewCriteria
        ? this.reasonReviewCriteria.id
        : null,
      notes: this.notes,
    };
  }
}
